import React, { useState, useEffect } from 'react';
import { NavLink, useHistory, NavDropdown } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import '../Style/studentHomeNav.css';


const Home = () => {
    const history = useHistory();
    const store = useSelector((store) => store);
    const [name, setName] = useState('');

    useEffect(() => {
        if (store.student.student.student.name) {
            setName(store.student.student.student.name);
        }
    }, [store.student.student.student.name]);

    const dispatch = useDispatch();

    return (
        <div className='mainNav'>
            <div className="row">
                <div className="col">
                    <nav className="navbar navbar-expand-lg navbar-light text-light">
                        <img src="/image/arjlogo.png" className="navbar-brand nav-img" alt="" />
                        <button
                            className="navbar-toggler text-light"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon" >
                                
                            </span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav borderUl w-100 d-flex justify-content-around">
                                <li className="nav-item w-100">
                                    <NavLink
                                        to="/home"
                                        activeClassName="active" 
                                        style={{ color: '#fff' }}
                                        className="nav-link custom-link"
                                    >
                                        Profile
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100">
                                    <NavLink
                                        to="/student/studentNoticeBoard"
                                        activeClassName="active" 
                                        style={{ color: '#fff' }}// Add this activeClassName
                                        className="nav-link custom-link"
                                    >
                                        Notice Board
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100">
                                    <NavLink
                                        to="/student/StudentResult"
                                        activeClassName="active"
                                        style={{ color: '#fff' }} // Add this activeClassName
                                        className="nav-link custom-link"
                                    >
                                        Result
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100">
                                    <NavLink
                                        to="/student/attendence"
                                        activeClassName="active"
                                        style={{ color: '#fff' }} // Add this activeClassName
                                        className="nav-link custom-link"
                                    >
                                        Attendance
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100">
                                    <NavLink
                                        to="/student/assignment"
                                        activeClassName="active"
                                        style={{ color: '#fff' }} // Add this activeClassName
                                        className="nav-link custom-link"
                                    >
                                        Assignment
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100">
                                    <NavLink
                                        to="/student/getAllSubjects"
                                        activeClassName="active"
                                        style={{ color: '#fff' }}// Add this activeClassName
                                        className="nav-link custom-link"
                                    >
                                        Subject
                                    </NavLink>
                                </li>
                                <li className="nav-item w-100">
                                    <NavLink
                                        to="/student/studentTimeTable"
                                        style={{ color: '#fff' }}
                                        activeClassName="active" // Add this activeClassName
                                        className="nav-link custom-link"
                                    >
                                        Time Table
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Home;
